import SectionMixin from '@/mixins/sectionMixin'
import creditCardForm from "@/components/forms/credit-card-form"


export default {
    name: 'feature-splited-cc-form-block',
    mixins: [SectionMixin],
    components: {
        "credit-card-form": creditCardForm,
    },
    props: {
        number: String,
        imgUrl: String,
        description: String,
        title: String,
        disclaimer: String,
    },
    data: () => {
        return {
            isIntersecting: false,
            visible: false,
        }
    },
    mounted() {

    },
    beforeDestroy() {

    },
    methods: {
        show() {
            if (this.visible) {
                return
            }
            this.visible = true
            this.$refs["form"].visible = true
        },
    }
}